import { useStore } from '@xyflow/react'
import { isAiConversationNode } from '../utils/ai-agent-utils'

export const useHasAINode = () => {
  return useStore((state) => state.nodes.some((node) => isAiConversationNode(node.type)))
}
